module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_6_2.6dfe55be.jpeg";